import { Constants } from "../constants/constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from "../utils/utils";

@Injectable({
  providedIn: "root"
})
export class TipoMotivoClasService {
  constructor(private http: HttpClient, private utils: Utils) {}

  public getTipoMotivoClas(idTipoMotivoClas): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_TIPO_MOTIVO_CLAS +
      "/" +
      idTipoMotivoClas;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError(err => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Tipo Motivo",
            text: "Error Cargando Tipo Motivo.",
            type: "error"
          });
        }

        return throwError(err);
      })
    );
  }

  public postTipoMotivoClas(params): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_TIPO_MOTIVO_CLAS;
    return this.http.post<any>(url, params).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Tipo Motivo Clas",
            text: "Verifique la informacion ingresada.",
            type: "error",
            confirmButtonColor: "#127570"
          });
        }

        return throwError(err);
      })
    );
  }

  public putTipoMotivoClas(idTipoMotivoClas, params): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_TIPO_MOTIVO_CLAS +
      "/" +
      idTipoMotivoClas;
    return this.http.put<any>(url, params).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Tipo Motivo Clas",
            text: "Error actualizando información del tipo motivo clas.",
            type: "error"
          });
        }

        return throwError(err);
      })
    );
  }

  public deleteTipoMotivoClas(idTipoMotivoClas, usuario): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_TIPO_MOTIVO_CLAS +
      "/" +
      idTipoMotivoClas +
      "/" +
      usuario;
    return this.http.delete<any>(url).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Tipo Motivo Clas",
            text: "Error eliminado información del tipo motivo clas.",
            type: "error"
          });
        }

        return throwError(err);
      })
    );
  }
}
